/**
 * Traduzioni IT per i dati provenienti da pesdb.net.
 * Manteniamo i valori inglesi nel DB (compatibilità con future re-sync)
 * e traduciamo solo quando mostriamo a video.
 *
 * IMPORTANTE: i nomi italiani sono presi 1:1 dalla versione italiana di
 * pesdb.net (?lang=ita) così la scheda giocatore è IDENTICA a PESDB.
 * Le abilità/stili che pesdb.net lascia in inglese restano in inglese.
 */

export const STAT_IT = {
    "Offensive Awareness": "Comportamento offensivo",
    "Ball Control": "Controllo palla",
    "Dribbling": "Dribbling",
    "Tight Possession": "Possesso stretto",
    "Low Pass": "Passaggio rasoterra",
    "Lofted Pass": "Passaggio alto",
    "Finishing": "Finalizzazione",
    "Heading": "Colpo di testa",
    "Set Piece Taking": "Calci da fermo",
    "Curl": "Tiro a giro",
    "Defensive Awareness": "Comportamento difensivo",
    "Tackling": "Contrasto",
    "Aggression": "Aggressività",
    "Defensive Engagement": "Coinvolgimento difensivo",
    "GK Awareness": "Comportamento PT",
    "GK Catching": "Presa PT",
    "GK Parrying": "Parata PT",
    "GK Reflexes": "Riflessi PT",
    "GK Reach": "Estensione PT",
    "Speed": "Velocità",
    "Acceleration": "Accelerazione",
    "Kicking Power": "Potenza di tiro",
    "Jumping": "Salto",
    "Physical Contact": "Contatto fisico",
    "Balance": "Controllo corpo",
    "Stamina": "Resistenza",
};

// Ordine "flat" identico a pesdb.net (Attacco → Difesa → Portiere → Fisico),
// usato per la scheda giocatore su due colonne.
export const STAT_ORDER_PESDB = Object.keys(STAT_IT);

export const FOOT_IT = {
    "Right foot": "Piede destro",
    "Left foot": "Piede sinistro",
    "Right": "Piede destro",
    "Left": "Piede sinistro",
};

export const FORM_IT = {
    "Inconsistent": "Incostante",
    "Standard": "Normale",
    "Unwavering": "Incrollabile",
};

export const INJURY_IT = {
    "Low": "Bassa",
    "Medium": "Media",
    "High": "Alta",
};

export const WEAK_FOOT_USAGE_IT = {
    "Almost Never": "Quasi mai",
    "Rarely": "Raramente",
    "Occasionally": "Sporadicamente",
    "Regularly": "Regolarmente",
};

export const WEAK_FOOT_ACCURACY_IT = {
    "Low": "Bassa",
    "Medium": "Media",
    "High": "Alta",
    "Very High": "Molto alta",
};

export const REGION_IT = {
    "Europe": "Europa",
    "South America": "Sud America",
    "North America": "Nord e Centro America",
    "North & Central America": "Nord e Centro America",
    "Africa": "Africa",
    "Asia": "Asia/Oceania",
    "Asia-Oceania": "Asia/Oceania",
    "Oceania": "Asia/Oceania",
};

export const PLAYING_STYLE_IT = {
    "Goal Poacher": "Opportunista",
    "Dummy Runner": "Senza palla",
    "Fox in the Box": "Rapace d'area",
    "Target Man": "Fulcro di gioco",
    "Roaming Flank": "Taglio al centro",
    "Cross Specialist": "Specialista di cross",
    "Prolific Winger": "Ala prolifica",
    "Classic No.10": "Classico nº 10",
    "Classic No. 10": "Classico nº 10",
    "Hole Player": "Giocatore chiave",
    "Box-to-Box": "Onnipresente",
    "Anchor Man": "Collante",
    "Orchestrator": "Tra le linee",
    "Creative Playmaker": "Regista creativo",
    "Deep-Lying Forward": "Attaccante di rientro",
    "Build Up": "Sviluppo",
    "The Destroyer": "Incontrista",
    "Destroyer": "Incontrista",
    "Defensive Full-back": "Terzino difensivo",
    "Offensive Full-back": "Terzino offensivo",
    "Full-back Finisher": "Terzino mattatore",
    "Defensive Goalkeeper": "Portiere difensivo",
    "Offensive Goalkeeper": "Portiere offensivo",
    "Extra Frontman": "Frontale extra",
};

export const POSITION_IT = {
    "GK": "Portiere",
    "CB": "Difensore Centrale",
    "LB": "Terzino Sinistro",
    "RB": "Terzino Destro",
    "DMF": "Mediano",
    "CMF": "Centrocampista",
    "LMF": "Esterno Sinistro",
    "RMF": "Esterno Destro",
    "AMF": "Trequartista",
    "LWF": "Ala Sinistra",
    "RWF": "Ala Destra",
    "SS": "Seconda Punta",
    "CF": "Attaccante",
};

// Sigle ruolo identiche al PESDB italiano (confermate dall'utente).
export const POSITION_SHORT_IT = {
    "GK": "POR",
    "CB": "DC",
    "RB": "TD",
    "LB": "TS",
    "DMF": "MED",
    "CMF": "CC",
    "AMF": "TRQ",
    "RMF": "CLD",
    "LMF": "CLS",
    "RWF": "EDA",
    "LWF": "ESA",
    "SS": "SS",
    "CF": "P",
};

export const STAT_GROUPS_IT = {
    "Attacco": [
        "Offensive Awareness", "Ball Control", "Dribbling", "Tight Possession",
        "Low Pass", "Lofted Pass", "Finishing", "Heading", "Set Piece Taking", "Curl",
    ],
    "Fisico": [
        "Speed", "Acceleration", "Kicking Power", "Jumping",
        "Physical Contact", "Balance", "Stamina",
    ],
    "Difesa": [
        "Defensive Awareness", "Tackling", "Aggression", "Defensive Engagement",
    ],
    "Portiere": [
        "GK Awareness", "GK Catching", "GK Parrying", "GK Reflexes", "GK Reach",
    ],
};

// Helpers
export const trStat = (key) => STAT_IT[key] || key;
export const trFoot = (v) => FOOT_IT[v] || v || "—";
export const trForm = (v) => FORM_IT[v] || v || "—";
export const trInjury = (v) => INJURY_IT[v] || v || "—";
export const trWeakFootUsage = (v) => WEAK_FOOT_USAGE_IT[v] || v || "—";
export const trWeakFootAccuracy = (v) => WEAK_FOOT_ACCURACY_IT[v] || v || "—";
export const trRegion = (v) => REGION_IT[v] || v || "—";
export const trStyle = (v) => PLAYING_STYLE_IT[v] || v || "—";
export const trPositionFull = (v) => POSITION_IT[v] || (v && v.length <= 5 ? v : "—");
export const trPositionShort = (v) => POSITION_SHORT_IT[v] || (v && v.length <= 5 ? v : "—");

// Player Skills (abilità giocatore) — nomi ufficiali pesdb.net IT (?lang=ita).
// Le abilità che pesdb.net lascia in inglese restano in inglese (identico al sito).
export const SKILL_IT = {
    "Scissors Feint": "Finta doppio passo",
    "Double Touch": "Doppio tocco",
    "Flip Flap": "Elastico",
    "Marseille Turn": "Veronica",
    "Sombrero": "Sombrero",
    "Chop Turn": "Svolta secca",
    "Cut Behind & Turn": "Taglio alle spalle e giro",
    "Scotch Move": "Rimbalzo interno",
    "Sole Control": "Controllo di suola",
    "Momentum Dribbling": "Momentum Dribbling",
    "Acceleration Burst": "Acceleration Burst",
    "Magnetic Feet": "Magnetic Feet",
    "Heading": "Colpo di testa",
    "Bullet Header": "Bullet Header",
    "Long-Range Curler": "A giro da distante",
    "Blitz Curler": "Blitz Curler",
    "Chip Shot Control": "Pallonetto mirato",
    "Knuckle Shot": "Tiro di collo",
    "Dipping Shot": "Tiri a scendere",
    "Rising Shot": "Tiro a salire",
    "Long Range Shooting": "Long Range Shooting",
    "Low Screamer": "Low Screamer",
    "Acrobatic Finishing": "Finalizzazione acrobatica",
    "Heel Trick": "Colpo di tacco",
    "First-time Shot": "Tiro di prima",
    "Phenomenal Finishing": "Phenomenal Finishing",
    "Willpower": "Willpower",
    "One-touch Pass": "Passaggio di prima",
    "Through Passing": "Passaggio filtrante",
    "Weighted Pass": "Passaggio calibrato",
    "Pinpoint Crossing": "Cross calibrato",
    "Edged Crossing": "Edged Crossing",
    "Outside Curler": "Esterno a giro",
    "Rabona": "Rabona",
    "No Look Pass": "No-look",
    "Game-changing Pass": "Game-changing Pass",
    "Visionary Pass": "Visionary Pass",
    "Phenomenal Pass": "Phenomenal Pass",
    "Low Lofted Pass": "Passaggio a scavalcare",
    "GK Low Punt": "Traiettoria bassa PT",
    "GK High Punt": "Rimessa profonda PT",
    "Long Throw": "Rimessa lunga",
    "GK Long Throw": "Rimessa lunga PT",
    "Penalty Specialist": "Specialista dei rigori",
    "GK Penalty Saver": "Para-rigori",
    "GK Directing Defence": "GK Directing Defence",
    "GK Spirit Roar": "GK Spirit Roar",
    "Gamesmanship": "Astuzia",
    "Man Marking": "Marcatore",
    "Track Back": "Tornante",
    "Interception": "Intercettazione",
    "Blocker": "Muro",
    "Aerial Superiority": "Dominio palle alte",
    "Sliding Tackle": "Scivolata",
    "Long-reach Tackle": "Long-reach Tackle",
    "Fortress": "Fortress",
    "Acrobatic Clearance": "Disimpegno acrobatico",
    "Aerial Fort": "Aerial Fort",
    "Shadow Hunt": "Shadow Hunt",
    "Captaincy": "Leader",
    "Attack Trigger": "Attack Trigger",
    "Super-sub": "Riserva di lusso",
    "Fighting Spirit": "Spirito combattivo",
    "Attacking Surge": "Attacking Surge",
};

// AI Playing Styles — nomi ufficiali pesdb.net IT (?lang=ita).
export const AI_STYLE_IT = {
    "Trickster": "Funambolo",
    "Mazing Run": "Serpentina",
    "Speeding Bullet": "Treno in corsa",
    "Incisive Run": "Inserimento",
    "Long Ball Expert": "Esperto palle lunghe",
    "Early Cross": "Cross dalla trequarti",
    "Long Ranger": "Tiratore",
};

export const trSkill = (v) => SKILL_IT[v] || v || "—";
export const trAiStyle = (v) => AI_STYLE_IT[v] || PLAYING_STYLE_IT[v] || v || "—";
